import React from "react";
import { Flex } from "@jsq/ds/core";
import { AchPaymentPrefDisplay } from "./AchPaymentPrefDisplay";
import { CheckPaymentPrefDisplay } from "./CheckPaymentPrefDisplay";
import { type PaymentPrefDetailsProps } from "./types";
import { WirePaymentPrefDisplay } from "./WirePaymentPrefDisplay";

/**
 * Component for displaying detailed payment preference information with configurable field visibility.
 *
 * This component automatically detects the payment type (ACH, Wire, or Check) and renders the appropriate
 * fields. You can control which fields are displayed using the `visibleFields` prop. If `visibleFields` is
 * omitted, all fields will be shown.
 */
export const PaymentPrefDetails: React.FC<PaymentPrefDetailsProps> = ({
  paymentPrefFull,
  checkDisplayOverride = {},
  visibleFields,
  showBankDomicile,
}: PaymentPrefDetailsProps) => {
  const achPaymentPref =
    paymentPrefFull?.__typename === "AchPaymentPrefObjectType" ? paymentPrefFull : undefined;

  const wirePaymentPref =
    paymentPrefFull?.__typename === "WirePaymentPrefObjectType" ? paymentPrefFull : undefined;

  const checkPaymentPref =
    paymentPrefFull?.__typename === "CheckPaymentPrefObjectType" ? paymentPrefFull : undefined;
  const { checkAddressOverride } = checkDisplayOverride;
  return (
    <Flex flexDirection="column">
      {achPaymentPref && (
        <AchPaymentPrefDisplay
          achPaymentPrefFull={achPaymentPref}
          visibleFields={visibleFields?.ach}
        />
      )}
      {wirePaymentPref && (
        <WirePaymentPrefDisplay
          wirePaymentPrefFull={wirePaymentPref}
          visibleFields={visibleFields?.wire}
          showBankDomicile={showBankDomicile}
        />
      )}
      {checkPaymentPref && (
        <CheckPaymentPrefDisplay
          checkPaymentPrefFull={checkPaymentPref}
          checkAddressOverride={checkAddressOverride}
          visibleFields={visibleFields?.check}
          showBankDomicile={showBankDomicile}
        />
      )}
    </Flex>
  );
};
